import React from 'react'

const DashboardIcon2 = ({ fill = "#FFF", width = "22", height = "22" }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_168_12271)">
                <path d="M44.9363 64V44.9362H64.0001" fill={fill} />
                <path d="M11.9148 11.9149H45.2765V38.1277H38.1276V19.0639H19.0637V38.1277H38.1276V45.2766H11.9148V11.9149Z" fill={fill} />
                <path d="M57.1915 0V38.1277H50.0425V7.14894H7.14894V50.0426H38.1277V57.1915H0V0H57.1915Z" fill={fill} />
            </g>

        </svg>

    )
}
export default DashboardIcon2
